

































































import calDay, { dayItem } from "./calDay.vue"
import {nextTick} from "process"
import iconButton from "./iconButtons.vue"
import loadIcon from "./loadIcon.vue"

import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import moment,{ weekdays, Moment } from "moment";
import { setInterval, setTimeout } from "timers";
import uuid from "uuid/v4";
import { frontendClient } from "../lib/client";

export interface CalendarStructure{
    currentDate: {
        weekday:number,
        day:number,
        month:number,
        monthName: string,
        monthShort: string,
        year:number,
    }
    items:{
        months: {
            name: string,
            year: string,
            monthLength:number,
            firstDay:Date,
            lastDay:Date,
            prevMonthLen:number,
            viewSpan?:{
                first: {
                    date: Date,
                    weekday: number,
                }
                last: {
                    date: Date,
                    weekday: number,
                },
                length:number
            },
            weeks:{
                index:number,
                days:dayItem[]
            }[]
        }[]
    }
}

@Component({
    components : {
        calDay,
        loadIcon,
        iconButton
    },
})
export default class Calendar extends Vue{

    @Prop({}) noBorder:boolean;
    @Prop({}) small:boolean;
    @Prop({}) navigation:boolean;
    @Prop({}) controller:boolean;
    @Prop({}) calDirection:number;
    @Prop({}) newDate:Date;

    // day selector is for selecting availabilities
    @Prop({
        default: false
    }) daySelector: boolean;

    // date selector is for use with the dateSelector component
    @Prop({}) dateSelector: boolean;

    view:number = 0;
    viewName:string = null;

    loading:boolean = true;

    incremenet:number = 0;
    calendar:CalendarStructure = null;
    filledCalendar:boolean = false;
    selectedDay:Date = null;
    focusDate:Date = null;
    focusWeek:Date[] = null;

    days: dayItem[] = null;
    setSmall:boolean = this.navigation || false;

    calUpdateCooldown:boolean = false;

    getView(){
        if(this.view == 0){

        }
    }

    async updateDate(specificDate?){

        if(this.$route.path == "/a/calendar"){
            nextTick(() => {
                frontendClient.giveError("Updating...");
            })
        }

        let params = this.$route.params;
        if(this.$route.params.date == null){
            this.$route.params.date = moment().format('DD/MM/YYYY');
        }

        if(specificDate){
            var currentMomentReturn:Moment = moment(specificDate, 'DD/MM/YYYY');
        }else{
            var currentMomentReturn:Moment = moment(this.$route.params.date, 'DD/MM/YYYY');            
        }

        this.focusDate = currentMomentReturn.toDate();
        this.focusWeek = [];
        let startOfWeek = moment(this.focusDate).startOf('week');
        let endOfWeek = moment(this.focusDate).endOf('week');
        while (startOfWeek <= endOfWeek) {
            this.focusWeek.push(startOfWeek.toDate());
            startOfWeek = startOfWeek.clone().add(1, 'd');
        }

        let newCalendar = {
            currentDate:{
                weekday: this.focusDate.getDay(),
                day: this.focusDate.getDate(),
                month: this.focusDate.getMonth(),
                monthName: moment(this.focusDate).format('MMMM'),
                monthShort: moment(this.focusDate).format('MM'),
                year: this.focusDate.getFullYear(),
            },
            items: {
                months: [],
            },
        }

        let datelengths={
            monthLen:1,
            weekLen:null,
            dayLen:null,
        }

        if(this.small){
            this.setSmall = true;
        }else{
            this.setSmall = false;
            switch(this.$route.params.calView){
                case '0':
                    // YEAR VIEW
                    this.viewName = "year";
                    datelengths.monthLen = 12;
                    this.setSmall = true;
                    break;
                case '1':
                    // month view
                    this.viewName = "month";
                    datelengths.monthLen = 1;
                    break;
                case '2':
                    // fourweek view
                    this.viewName = "fourWeeks";
                    datelengths.weekLen = 3; // 3 as we move back 1 week too
                    break;
                case '3':
                    // fortnight view
                    this.viewName = "week";
                    datelengths.weekLen = 2;
                    break;
                case '4':
                    // week view
                    this.viewName = "week";
                    datelengths.weekLen = 1;
                    break;
                case '5':
                    // day view
                    this.viewName = "day";
                    datelengths.dayLen = 0;
                    break;
                default:
                    // month view
                    this.viewName = "month";
                    datelengths.monthLen = 1;
                    break;
            }
        }

        let content:any[] = await this.getMonths(newCalendar.currentDate.year,datelengths,newCalendar);

        newCalendar.items = {
            months:content
        }
        
        this.filledCalendar = true;
        this.loading = false;
        this.calendar = newCalendar;
        this.$emit("calStateChange", newCalendar)

        if(this.$route.path == "/a/calendar"){
            setTimeout(() => {
                this.$route.params.reodering = null;
                frontendClient.clearError();
            },0);
        }
        this.calUpdateCooldown = false;
    }

    changeFocus(day){
        if(this.controller){
            this.$route.params.date = moment(day.date).format('DD/MM/YYYY');
            window['controllerChangedDate'](day.date);
        }else{
            this.focusDate = moment(day.date).toDate();
            this.calendar.currentDate = {
                weekday: this.focusDate.getDay(),
                day: this.focusDate.getDate(),
                month: this.focusDate.getMonth(),
                monthName: moment(this.focusDate).format('MMMM'),
                monthShort: moment(this.focusDate).format('MM'),
                year: this.focusDate.getFullYear(),
            }
            this.updateDate(this.focusDate);
        }
        this.$emit("calendarFocusChanged")
    }

    selectDay(day){
        this.$emit('dateSelected',day.date) 
    }

    getMonths(year:number, {monthLen,weekLen,dayLen}, newCalendar: CalendarStructure){
        return new Promise<any[]>((resolve, reject) =>{
            let months:Moment[] = [];
            nextTick(async ()=>{
                if(monthLen > 1){
                    for(let i=0;i<monthLen;i++){
                        months.push(moment().year(year).month(i));
                    }
                }else{
                    months.push(moment().year(year).month(newCalendar.currentDate.month))
                }

                let monthContent = [];
                for(let i=0; i<months.length;i++){

                    let monthName = months[i].format('MMM');
                    let yearName = months[i].format('YYYY');

                    let monthLength = months[i].daysInMonth();
                    let lastMonthReturn = moment(months[i]).subtract(1,'months');
                    let prevMonthLen = lastMonthReturn.daysInMonth();

                    let yearNum = months[i].year()
                    let monthNum = months[i].month();
                    let firstDay, lastDay;

                    let firstDate, lastDate;
                    if(weekLen ==null && dayLen == null){
                        firstDay = new Date(yearNum, monthNum, 1);
                        lastDay = new Date(yearNum, monthNum + 1, 0);
                        firstDate = moment(firstDay).subtract((firstDay.getDay()),'days').toDate();
                        lastDate = moment(lastDay).add((6-lastDay.getDay()),'days').toDate();
                    }else if(weekLen != null){
                        if(this.viewName == "fourWeeks"){
                            firstDay = moment(this.focusDate).subtract((newCalendar.currentDate.weekday)+7,'days').toDate();
                        }else{
                            firstDay = moment(this.focusDate).subtract((newCalendar.currentDate.weekday),'days').toDate();
                        }
                        lastDay = moment(this.focusDate).add(((weekLen-1) * 7)+(6-newCalendar.currentDate.weekday),'days').toDate();
                        firstDate = firstDay;
                        lastDate = lastDay;
                    }else if(dayLen != null){
                        firstDay = this.focusDate;
                        lastDay = moment(this.focusDate).add(dayLen,'days').toDate();
                        firstDate = firstDay;
                        lastDate = lastDay;
                    }

                    let viewLength = 1 + moment(lastDate).diff(moment(firstDate), 'days');   
                    let weeks;     
                    if(this.daySelector || this.dateSelector) {
                        weeks = await this.getDaysEx(firstDate, viewLength, {monthLen,weekLen,dayLen});
                    }
                    else {
                        weeks = await this.getDays(firstDate, viewLength, {monthLen,weekLen,dayLen});
                    }

                    monthContent.push({
                        month: monthName,
                        year: yearName,
                        monthLength: monthLength,
                        firstDay: firstDay,
                        lastDay: lastDay,
                        prevMonthLen: prevMonthLen,
                        viewSpan: {
                            first:{
                                date: firstDate, 
                                weekday: firstDay.getDay(),
                            },
                            last:{
                                date: lastDate,
                                weekday: lastDay.getDay(),
                            },
                            length: viewLength
                        },
                        weeks:weeks
                    });
                }

                resolve(monthContent);
            })
        })
    }

    async getDays(firstDate:Date, numberOfDays:number, {monthLen,weekLen,dayLen}){

        let weekCount:number = 0;
        let weeks:any[] = null;
        let data:any = null;

        // MAKE SURE THE CALENDAR IS ONLY THE BIG BOI
        if(!this.small && !this.navigation && !this.controller){
            data = await frontendClient.postEx('jobs/list/date', {
                from: firstDate.getTime(),
                to: moment(firstDate).add(numberOfDays + 1,'days').toDate().getTime(),
            })
        }

        for(let i=0; i<numberOfDays; i++){
            let day = moment(firstDate).add(i,'days').toDate();
            let processedEntries: dayItem["children"] = [];

            if(!this.small && !this.navigation && !this.controller){
                let entries = data.days[i];
                for(let entry of entries) {
                    processedEntries.push(entry)
                }
            }

            let dayInsert:dayItem = {
                dayOfWeek: day.getDay(),
                date: (day).getTime(),
                range: null,
                children: processedEntries, // << in here can go an async request for data
            }

            if(i%7 == 0){
                if(weeks == null){
                    weeks = [{
                        index: weekCount,
                        days:[dayInsert]
                    }];
                }else{
                    weekCount++;
                    weeks.push({
                        index: weekCount,
                        days:[dayInsert]
                    })
                }
            }else{
                weeks[weekCount].days.push(dayInsert);
            }
        }

        return weeks;
    }

    async getDaysEx(firstDate:Date, numberOfDays:number, {monthLen,weekLen,dayLen}){
        let weekCount:number = 0;
        let weeks:any[] = null;
        let data:any = null;

        if(!this.small && !this.navigation && !this.controller){
            data = await frontendClient.postEx('jobs/usergroups/offers/listavailability', {
                from: firstDate.getTime(),
                to: moment(firstDate).add(numberOfDays + 1,'days').toDate().getTime(),
            });
        }

        for(let i=0; i<numberOfDays; i++){
            let day = moment(firstDate).add(i,'days').toDate();

            let dayInsert:dayItem = {
                dayOfWeek: day.getDay(),
                date: (day).getTime(),
                range: data ? ((data.days[i] && data.days[i][0]) ? (data.days[i][0].canWork ? 1 : 0) : null) : null,
                children: [],
            }

            if(i%7 == 0){
                if(weeks == null){
                    weeks = [{
                        index: weekCount,
                        days:[dayInsert]
                    }];
                }else{
                    weekCount++;
                    weeks.push({
                        index: weekCount,
                        days:[dayInsert]
                    })
                }
            }else{
                weeks[weekCount].days.push(dayInsert);
            }
        }

        return weeks;
    }

    rangeUpdate(dayItem){
        let placeholder:any = {}; 
        let prevRange = dayItem.range;
        placeholder = Object.assign(placeholder,dayItem);
        if(this.daySelector){
            if(placeholder.range == 1){
                placeholder.range = 0;
            }else{
                placeholder.range = 1;
            }
            frontendClient.postEx("jobs/usergroups/offers/setavailability",{
                timestamp: placeholder.date,
                canWork: placeholder.range == 1,
            }).then(() => {
                if(dayItem.range != 0 && dayItem.range != null){
                    dayItem.range = 0;
                }else{
                    dayItem.range = 1;
                }
            }).catch(() => {
                dayItem.range = 2;
                setTimeout(()=>{
                    dayItem.range = prevRange;
                },20)
            })
        }else{
            this.selectedDay = dayItem.date;
        }
    }

    updateCb: any;
    calCooldown:boolean = false;
    mounted(){

        let updateTimerID;
        this.updateCb = (data) => {
            if(data.availchange) return;
            if(this.calUpdateCooldown) return;
            this.calUpdateCooldown = true;

            if(updateTimerID) {
                clearTimeout(updateTimerID);
            }

            updateTimerID = setTimeout(() => {
                updateTimerID = null;
                this.updateDate(this.focusDate);
            },275);
        };
        frontendClient.wsClient.on("updatecal",this.updateCb);

        window['controllerChangedDate'] = (date:number) => {
            if(!this.controller && !this.navigation){
                this.focusDate = moment(date).toDate();
                console.log(this.focusDate);
                this.updateDate(this.focusDate);
            }
        }

        nextTick(() => {
            this.updateDate().then(() => {
                this.$emit("calendarFocusChanged")
            });
            this.getView();
            
            let prevCalView = null;

            setInterval(() => {
                if(this.$route.params.calView != prevCalView && !this.controller && !this.navigation){
                    prevCalView = this.$route.params.calView;
                    this.$route.params.date = moment(this.focusDate).format('DD/MM/YYYY');
                    this.updateDate(this.$route.params.date);
                }
            },100);

        })
        this.eventListeners()
    }

    

    beforeDestroy() {
        frontendClient.wsClient.removeListener("updatecal",this.updateCb);
    }

    eventListeners(){
        let cal = (this.$refs.gCalendar as HTMLElement);
        cal.addEventListener('touchstart', this.handleTouchStart, false);
        cal.addEventListener('touchend', this.handleTouchEnd, false);
        cal.addEventListener('touchmove', this.handleTouchMove, false);
    }


    xDown = null;                                                        
    yDown = null;

    getTouches(evt) {
    return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    }                                                     

    handleTouchStart(evt) {
        const firstTouch = this.getTouches(evt)[0];                                      
        this.xDown = firstTouch.clientX;                                      
        this.yDown = firstTouch.clientY;                                      
    };         
    
    handleTouchEnd(){
        this.xDown = null;
        this.yDown = null; 
    }

    handleTouchMove(evt) {
        if ( !this.xDown || !this.yDown ) {
            return;
        }

        var xUp = evt.touches[0].clientX;                                    
        var yUp = evt.touches[0].clientY;

        var xDiff = this.xDown - xUp;
        var yDiff = this.yDown - yUp;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
            if ( xDiff > 100 ) {
                this.moveCalendar(1);
                this.handleTouchEnd();
            } else if(xDiff < -100){
                this.moveCalendar(-1);
                this.handleTouchEnd();
            }                       
        }else{
            if(yDiff > 50 || yDiff<50){
                /* reset values */
                this.handleTouchEnd();
            }
        }
    };

    calUpdate(direction){
        this.moveCalendar(direction);
    }

    @Watch('calDirection')
    moveCalendar(to,from?){
        this.loading = true;
        setTimeout(() => {
            // watching to
            // +x = move forward x
            // -x = move backward x

            if(!this.viewName){
                this.viewName = "month";
            }

            let increment = this.viewName;
            if(this.viewName == "fourWeeks"){
                increment = "week"
            }

            if(to != 0){
                let newDate:string;

                if(to > 0){
                    newDate = moment(this.focusDate).add(to, increment).format('DD/MM/YYYY');
                }else if(to != 0){
                    to *= -1;
                    newDate = moment(this.focusDate).subtract(to, increment).format('DD/MM/YYYY');
                }

                if(!this.controller){
                    this.$route.params.date = newDate;
                    this.updateDate(this.$route.params.date).then(() => {
                        this.$emit("calendarFocusChanged")
                    })
                }else{
                    this.updateDate(newDate).then(() => {
                        this.$emit("calendarFocusChanged")
                    });
                }

            }
        },50)
        
    }

    @Watch('newDate')
    moveCalendarToDate(to){

        this.loading = true;
        nextTick(() => {
            // watching to
            // +x = move forward x
            // -x = move backward x
            this.updateDate(to).then(() => {
                this.$emit("calendarFocusChanged")
            });
        })
        
    }

    @Watch('$route.params.scope')
    initiateLoad(){
        if(!this.small) {
            this.loading = true;
            nextTick(() => {
                this.updateDate();
            })
        };
        
    }
}
